import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "button"
  ];

  connect() {
    this.element.addEventListener("click", this.click, true)
  }

  disconnect() {
    this.element.removeEventListener("click", this.click)
  }


  async click(e) {
    e.preventDefault();
    this.closest('#auth-modal').classList.remove('show', 'd-block');
  }
}
